module.exports = __webpack_public_path__ + "img/sgp_cdc.96f9664a.jpg";